var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCompanyCallIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call",
    transform: "translate(-1167 -271)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 24,
    height: 24,
    rx: 3,
    transform: "translate(1167 271)",
    fill: "#f4f4f6",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "moving_ministry_FILL0_wght300_GRAD-25_opsz20",
    d: "M70.424-781.816v-12.26h9.01v12.26H75.927v-3.25h-2v3.25H70.424Zm.936-.936H73V-786h3.868v3.25H78.5V-793.14H71.36ZM73-787.637h1.117v-1.117H73Zm0-2.751h1.117V-791.5H73Zm2.751,2.751h1.117v-1.117H75.746Zm0-2.751h1.117V-791.5H75.746Zm8.2,4.921-.672-.661,1.357-1.349H81.369v-.936h3.263l-1.357-1.346.672-.664,2.476,2.48ZM73-782.752V-786h3.868v0H73Z",
    transform: "translate(1100.576 1070.946)",
    fill: "#3b3b3b"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCompanyCallIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/companyCallIcon.de39cde1.svg";
export { ForwardRef as ReactComponent };